import React, { useState } from "react";
import { useFormContext } from "react-hook-form";
import { ErrorMessage } from "@hookform/error-message";
import { SelectXProps } from "./types";
import Label from "./label";
import Select, { OptionsOrGroups } from "react-select"
import { useEffectOnce } from "../../../../lib-shared/src/hooks";
import { observer } from "mobx-react-lite";

const selectColumnCss = "selectx-col";

export const SelectX = observer((props: SelectXProps) => {
    const { setValue, getValues, register, trigger, formState: { errors } } = useFormContext();

    const [hasValue, setHasValue] = useState(false);

    const {
        name,
        options,
        label,
        labelCssName = "",
        fieldOptions,
        // usePlaceholder = false,
        placeHolder,
        isClearable = false,
    } = props;

    let cssName = props.cssName ?? "";

    const handleValueChange = (option: any) => {
        setHasValue(option && option.value !== "");
        setValue(props.name, option?.value);

        if (!!props.onChange) {
            props.onChange(option?.value);
        }

        trigger(name);
    }

    const usePlaceholder = true;

    if (!cssName.includes(selectColumnCss)) {
        cssName += ` ${selectColumnCss}`;
    }

    const cssForLabel = labelCssName + (usePlaceholder ? (hasValue ? " visible" : " hidden") : "");
    const placeholderText = usePlaceholder
        ? placeHolder ?? label
        : "";

    const selectOptions = options as OptionsOrGroups<any, any>;
    const defaultValue = selectOptions.find(x => x.value === getValues(name));

    useEffectOnce(() => {
        if (defaultValue) {
            setHasValue(true);
        }
    });

    return (<div className={cssName}>
        <Label htmlFor={name} cssName={cssForLabel} text={label} />

        <Select
            id={name}
            className="react-select-container"
            classNamePrefix="react-select"
            defaultValue={defaultValue}
            placeholder={placeholderText}
            isClearable={isClearable}
            isSearchable={false}
            {...register(name, fieldOptions)}
            onChange={handleValueChange}
            styles={{
                control: (baseStyles, state) => ({
                    ...baseStyles,
                    border: 0,
                    borderBottom: "1px solid #ccc",
                    borderRadius: 0,
                    boxShadow: "none"
                }),
                indicatorSeparator: (base, props) => ({
                    display: "none"
                }),
                menu: (baseStyles, state) => ({
                    ...baseStyles,
                    borderRadius: 0
                }),
                menuList: (baseStyles, state) => ({
                    ...baseStyles,
                    boxShadow: "0 0 5px rgba(0,0,0,.3)",
                    borderRadius: 0
                }),
                option: (baseStyles, state) => ({
                    color: "#00aeef",
                    fontSize: "11px",
                    padding: "15px 20px",
                    borderRadius: 0,
                    cursor: "pointer",
                    ":hover": {
                        backgroundColor: "rgba(10,18,29,.051)",
                        fontWeight: 600
                    }
                })
            }}
            options={selectOptions} />

        <ErrorMessage
            errors={errors}
            name={name}
            render={({ message }) => <p className="error">{message}</p>}
        />
    </div>);
});

export default SelectX;